import { Box, BoxProps } from '@mui/system';
import { FunctionComponent, PropsWithChildren } from 'react';

export const ActionBox: FunctionComponent<PropsWithChildren<BoxProps>> = (
  props,
) => {
  const { children, ...boxProps } = props;
  return (
    <Box
      sx={{
        '&:hover': {
          borderColor: 'primary.light',
        },
        border: '1px solid',
        borderColor: 'primary.main',
        cursor: 'pointer',
      }}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
